module.exports = __webpack_public_path__ + "img/apply.b6327e41.png";